import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MaterialEntryService } from '../../../services/material-entry.service';
import { MaterialEntry } from '../../../models/material-entry.model';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { FormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { InputTextModule } from 'primeng/inputtext';
import { Subject, Subscription, debounceTime, distinctUntilChanged } from 'rxjs';
import { PaginatorModule } from 'primeng/paginator';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'app-list-material-entry',
  standalone: true,
  imports: [
    CommonModule,
    TableModule,
    ButtonModule,
    FormsModule,
    InputTextModule,
    PaginatorModule,
    TooltipModule
  ],
  templateUrl: './list-material-entry.component.html'
})
export class ListMaterialEntryComponent implements OnInit {
  private searchSubject = new Subject<string>();
  private searchSubscription?: Subscription;

  entries: MaterialEntry[] = [];
  searchTerm = '';
  loading = true;

  first = 0;
  /** Deve ser igual ao pageSize da API para a paginação bater (API retorna 5 por página) */
  rows = 5;
  totalRecords = 0;
  currentPage = 1;

  constructor(
    private materialEntryService: MaterialEntryService,
    public router: Router
  ) {
    this.searchSubscription = this.searchSubject.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe(() => this.loadEntries());
  }

  ngOnInit(): void {
    this.loadEntries();
  }

  onSearchChange(): void {
    this.searchSubject.next(this.searchTerm);
  }

  loadEntries(): void {
    this.loading = true;
    this.materialEntryService.list(this.searchTerm, this.currentPage).subscribe({
      next: (res) => {
        const data = res.data as any;
        this.entries = Array.isArray(data) ? data : (data?.data ?? []);
        this.totalRecords = res.pagination?.totalRecords ?? data?.pagination?.totalRecords ?? data?.totalItems ?? 0;
        const page = res.pagination?.currentPage ?? data?.pagination?.currentPage ?? this.currentPage;
        this.currentPage = page;
        this.first = (this.currentPage - 1) * this.rows;
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      }
    });
  }

  onPageChange(event: any): void {
    this.first = event.first;
    this.currentPage = Math.floor(this.first / this.rows) + 1;
    this.loadEntries();
  }

  createEntry(): void {
    this.router.navigate(['/app/material-entries/new']);
  }

  viewEntry(entry: MaterialEntry): void {
    if (entry.id) {
      this.router.navigate(['/app/material-entries/view', entry.id]);
    }
  }
}
